import React, { useState, useContext, useEffect, useRef } from "react";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import { useMutation, gql } from "@apollo/client";
import axios from "axios";

import "../../../assets/css/Login.css";
import { LOGIN_WITH_GOOGLE } from "../../../graphql/mutations";
import { Link, OutlinedInput } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Define the GraphQL login mutation
const LOGIN_USER = gql`
  mutation login_user($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
    }
  }
`;

const Login = (props) => {
  const [user, setUser] = useState([]);
  const [profile, setProfile] = useState([]);

  const navigate = useNavigate(); // React Router hook for navigation
  const [loginWithGoogleMutation] = useMutation(LOGIN_WITH_GOOGLE);
  const [updating, setUpdating] = useState(false);
  var notificationRef = useRef();
  // Define Google login handler
  const login = useGoogleLogin({
    onSuccess: (response) => {
      setUser(response);
      console.log(response);
      // Call the loginWithGoogle mutation with the Google token
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${response.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${response.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          // Try to login with Google
          loginWithGoogleMutation({ variables: { email: res.data.email } })
            .then((result) => {
              // On successful login, store token and navigate to app events
              localStorage.setItem(
                "token",
                result?.data?.loginWithGoogle?.token
              );
              props.login(result?.data?.loginWithGoogle?.token);
              navigate("/app/events");
            })
            .catch((err) => {
              // On error, redirect to signup
              setUpdating(true);
              console.log(err);
              setTimeout(() => { window.location.href = "/signup?email=" + res.data.email; }, 2000)
            });
        });
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  // Get user's profile info when the user state changes
  useEffect(() => {
    if (user?.access_token) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setProfile(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [user]);
  // log out function to log the user out of google and set the profile array to null
  const timerRef = useRef(null);

  useEffect(() => {
    if (updating) {
      // Show notification for 2 seconds
      timerRef.current = setTimeout(() => {
        setUpdating(false);
      }, 1000);
    } else {
      // Cancel any pending timers
      clearTimeout(timerRef.current);
    }
  }, [updating]);

  // Google logout function
  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  // Input validation and submission handling
  const [email, setEmail] = useState(
    new URLSearchParams(window.location.search).get("email")
      ? new URLSearchParams(window.location.search).get("email")
      : ""
  );
  const [password, setPassowrd] = useState("");
  const [loginUser, { error: mutationError, data }] = useMutation(LOGIN_USER);
  const [validate, setValidate] = useState("");

  // Validate email format
  const validateEmail = (mail) => {
    const emailRex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(mail)) {
      setValidate("has-success");
    } else {
      setValidate("has-danger");
    }
  };
  const [error, setError] = useState("");
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = [];

    loginUser({ variables: { email, password } })
      .catch((res) => {
        res.graphQLErrors.map((err) => errors.push(err.message));
        setError(errors);
        return;
      })
      .then((result) => {
        if (errors.length === 0) {
          // If no errors, store token and navigate to app events
          localStorage.setItem("token", result?.data?.login?.token);
          props.login(result?.data?.login?.token);
          navigate("/app/events");
        }
      });
  };

  // Render form
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div className="Login-Popup-form">
        <form
          onSubmit={handleSubmit}
          style={{ padding: "50px", paddingBottom: "20px" }}
        >
          <h3 className="Loginyouraccount">Login to your account</h3>
          <p className="input-label">Email</p>
          <OutlinedInput
            type="text"
            value={email}
            fullWidth
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className="input-label">Password</p>
          <OutlinedInput
            fullWidth
            type="password"
            value={password}
            onChange={(e) => setPassowrd(e.target.value)}
          />
          <Link style={{ margin: '10px 0', cursor: 'pointer' }} href="/forgotpassword">Forgot your password?</Link>
          <button type="submit" className="login-button">
            Login
          </button>
        </form>
        <p style={{ color: "red" }}>{error}</p>
        <div style={{ padding: "30px" }}>
          <div>
            <button className="login-with-google-btn" onClick={() => login()}>
              Sign in with Google
            </button>
          </div>
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}
          >
            <p>Don't have an account?</p>
            <a href="/signup">Sign Up</a>
          </div>
        </div>
        {updating && (
          <div ref={notificationRef} className="notification s">
            Please Sign Up
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
